import React, { useState, useEffect, useLayoutEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/profile.css";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import moment from "moment-timezone";
import AdminSideNav from "../../components/layout/adminSideNav";
import { getTimezoneByCountry } from "../../utils/getTimezoneByCountry";

const AdminProfilePage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("AdminInfo")) || {}
  );
  const country = userInfo?.country || "Unknown";
  const [isLogginOut, setIsLogginOut] = useState(false);
  const [version, setVersion] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/admin/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem("AdminInfo", JSON.stringify(response.data.data));
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [navigate, showToast]);

  const handelLogout = () => {
    if (isLogginOut) return;
    setIsLogginOut(true);
    api
      .post("/api/publisher/logout")
      .then((response) => {
        localStorage.removeItem("aToken");
        localStorage.removeItem("PublisherInfo");
        showToast({
          status: response.data.status ? "success" : "error",
          message:
            response.data.message || response.data.status
              ? "Logged out successfully."
              : "Something went wrong.",
        });
        navigate("/auth/login");
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Something went wrong.",
        });
        setIsLogginOut(false);
      });
  }

  useLayoutEffect(() => {
    const scriptTag = document.querySelector('script[src*="v="]');
    const linkTag = document.querySelector('link[href*="v="]');

    let v = null;

    if (scriptTag) {
      const src = new URL(scriptTag.src);
      v = src.searchParams.get("v");
    }

    if (!v && linkTag) {
      const href = new URL(linkTag.href);
      v = href.searchParams.get("v");
    }

    setVersion(v);
  }, []);

  return (
    <div className="profile__page">
      <AdminSideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>My Profile</h2>
            <p>Manage your profile easily from here.</p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>My Profile</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>
        <div className="top-container">
          <div className="info-container">
            <div className="basic-infos">
              <div className="pimg-container">
                <Icon name="UserCircle" />
              </div>
              <div>
                <span>{userInfo.name || "Loading..."}</span>
                <span>{userInfo.role ? userInfo.role.charAt(0).toUpperCase() + userInfo.role.slice(1).toLowerCase() : "Loading..."}</span>
              </div>

              <button className="logoutBtn" disabled={isLogginOut} onClick={handelLogout}>
                {isLogginOut ? (
                  <Icon name="ArrowPath" className="spin onRight" />
                ) : (
                  <Icon name="ArrowRightStartOnRectangle" />
                )}
              </button>
            </div>
            <div className="more-infos">
              <div className="more-info">
                <div className="info">
                  <span>Email ID:</span>
                  <span>{userInfo.email || "Loading..."}</span>
                </div>
              </div>
              <div className="more-info">
                <div className="info">
                  <span>Mobile Number:</span>
                  <span>
                    {`+91 ${userInfo.phone || "9999999999"}` || "Not Set"}
                  </span>
                </div>
              </div>
              <div className="more-info">
                <div className="info">
                  <span>Payment Method:</span>
                  <span>UPI</span>
                </div>
              </div>
              <div className="more-info">
                <div className="info">
                  <span>Country</span>
                  <span>{country}</span>
                </div>
              </div>
              <div className="more-info">
                <div className="info">
                  <span>Joined Swift Digital Ads On:</span>
                  <span>
                    {moment(userInfo.assignedAt)
                      .tz(getTimezoneByCountry(country))
                      .format("DD MMM YYYY")}
                  </span>
                  <span className="version">v: {version}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <span className="copyright-text">
          © 2025 Swift Digital Ads, All rights reserved
        </span>
      </main>
    </div>
  );
};

export default AdminProfilePage;
